import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// Material Design Modules
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

// Component
import { BetriebskontaktAuswahlComponent } from './betriebskontakt-auswahl.component';
import { BetriebskontakteDialogsModule } from './betriebskontakte-dialogs.module';

@NgModule({
    declarations: [BetriebskontaktAuswahlComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatTooltipModule,
        BetriebskontakteDialogsModule,
    ],
    exports: [BetriebskontaktAuswahlComponent],
})
export class BetriebskontaktAuswahlModule {}
